import React, {forwardRef} from "react";
import classNames from "classnames";

import {svgIconWrapper} from "./SvgIconWrapper.module.css";

export type WrapperType = "circle" | "square";

interface IProps {
    children: React.ReactNode;
    wrapperColor: string;
    wrapperSize: string;
    wrapperType?: WrapperType;
    className?: string;
    onClick?: (event: React.MouseEvent) => void;
    as?: React.ElementType;
    "data-testid"?: string;
}

export const SvgIconWrapper = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const wrapperType = props.wrapperType || "circle";
    const borderRadius = wrapperType === "circle" ? "50%" : "0%";
    const wrapperSize = {minWidth: `${props.wrapperSize}rem`, width: `${props.wrapperSize}rem`, height: `${props.wrapperSize}rem`};
    const wrapperColor = {backgroundColor: props.wrapperColor};
    const wrapperStyle = {borderRadius, ...wrapperSize, ...wrapperColor};
    const svgIconWrapperCN = classNames(svgIconWrapper, props.className);

    return (
        <div style={wrapperStyle} className={svgIconWrapperCN} onClick={props.onClick} ref={ref} data-testid={props["data-testid"]}>
            {props.children}
        </div>
    );
});
import React, {forwardRef} from "react";
import classNames from "classnames";

import {svgIconWrapper} from "./SvgIconWrapper.module.css";

export type WrapperType = "circle" | "square";

interface IProps {
    children: React.ReactNode;
    wrapperColor: string;
    wrapperSize: string;
    wrapperType?: WrapperType;
    className?: string;
    onClick?: (event: React.MouseEvent) => void;
    as?: React.ElementType;
    "data-testid"?: string;
}

export const SvgIconWrapper = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const wrapperType = props.wrapperType || "circle";
    const borderRadius = wrapperType === "circle" ? "50%" : "0%";
    const wrapperSize = {minWidth: `${props.wrapperSize}rem`, width: `${props.wrapperSize}rem`, height: `${props.wrapperSize}rem`};
    const wrapperColor = {backgroundColor: props.wrapperColor};
    const wrapperStyle = {borderRadius, ...wrapperSize, ...wrapperColor};
    const svgIconWrapperCN = classNames(svgIconWrapper, props.className);

    return (
        <div style={wrapperStyle} className={svgIconWrapperCN} onClick={props.onClick} ref={ref} data-testid={props["data-testid"]}>
            {props.children}
        </div>
    );
});
